import { IFilter, IFilterDetails } from '@/modules/calendar/interfaces/IFilter';

export function onlyUnique(value: string, index: number, self: string[]) {
    return self.indexOf(value) === index;
}

export function onlyUniqueNumbers(value: number, index: number, self: number[]) {
    return self.indexOf(value) === index;
}

function getSingleFilterString({ odataName, compareType, value }: IFilterDetails): string {
    if (odataName === 'WeekDayId' || odataName === 'StartDate') {
        return `${odataName} ${compareType} ${value}`;
    }
    return `${odataName} ${compareType} '${value}'`;
}

export function buildFilter(allValues: IFilter[][]): string {
    const result = allValues
        .map((item: IFilter[]) => {
            const values = Object.values(item);
            const singleFilters = values
                .map((singleFilter: IFilter) => {
                    return getSingleFilterString(singleFilter.details);
                })
                .join(' or ');
            return `(${singleFilters})`;
        })
        .join(' and ');
    return result.length ? `${result}` : '';
}

export function getFiltersUrl(filters: IFilter[][]): string {
    const allValues = Object.values(filters);
    const result = buildFilter(allValues);
    return result.length ? ` and ${result}` : '';
}

export function buildCollectionFilter(allValues: IFilter[][]): string {
    const result = allValues
        .map((item: IFilter[]) => {
            const values: IFilter[] = Object.values(item);
            const singleFilters = values
                .map((singleFilter: IFilter) => {
                    return getSingleFilterString(singleFilter.details);
                })
                .join(' or x/');
            const collectionName = values[0].odataName;
            return `(${collectionName}/any(x: x/${singleFilters}))`;
        })
        .join(' and ');
    return result.length ? `${result}` : '';
}
